module.exports = __webpack_public_path__ + "img/2.776993f8.jpg";